<template>
  <v-flex
    v-if="currentDocuments.length > 0 || pictureUrl != ''"
    pt-2
    class="field-padding"
    row
    wrap
  >
    <v-flex xs12>
      <h4 class="grey--text text--darken-1">Current Files</h4>
    </v-flex>
    <v-layout row>
      <v-flex 12 xs12 md>
        <v-list v-if="pictureUrl != null && pictureUrl != ''">
          <v-fade-transition>
            <v-list-item v-if="!showCheckDeletePicture" avatar @click>
              <v-list-item-avatar>
                <v-img :src="pictureUrl" />
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>Driver Image</v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                <v-layout row>
                  <v-flex pr-2>
                    <v-btn icon @click="viewPicture">
                      <v-icon>visibility</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex pl-2>
                    <v-btn icon @click="checkDeletePicture">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-list-item-action>
            </v-list-item>
            <v-list-item v-if="showCheckDeletePicture" avatar @click dark class="checkDeleteTile">
              <v-list-item-avatar>
                <v-icon>delete</v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title class="white--text">Are you sure you want to delete Driver Image?</v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                <v-layout row>
                  <v-flex pr-2>
                    <v-btn icon @click="deletePicture">
                      <v-icon>check</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex pl-2>
                    <v-btn icon @click="keepPicture">
                      <v-icon>clear</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-list-item-action>
            </v-list-item>
          </v-fade-transition>
        </v-list>
        <v-list>
          <v-list-item
            v-for="document in currentDocuments"
            :key="document.id"
            v-bind:class="{ checkDeleteTile: showCheckDeleteDocuments[document.id] }"
            :dark="showCheckDeleteDocuments[document.id]"
            avatar
            @click
          >
            <v-list-item-avatar>
              <v-icon v-if="!showCheckDeleteDocuments[document.id]">insert_drive_file</v-icon>
              <v-icon v-if="showCheckDeleteDocuments[document.id]">delete</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title v-if="!showCheckDeleteDocuments[document.id]">{{ document.name }}</v-list-item-title>
              <v-list-item-sub-title
                v-if="!showCheckDeleteDocuments[document.id]"
              >{{ document.description }}</v-list-item-sub-title>

              <v-list-item-title
                class="white--text"
                v-if="showCheckDeleteDocuments[document.id]"
              >Are you sure you want to delete {{document.name}}?</v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <v-layout row v-if="!showCheckDeleteDocuments[document.id]">
                <v-flex pr-2>
                  <v-btn icon @click="viewDocument(document.id)">
                    <v-icon>visibility</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex pl-2>
                  <v-btn icon @click="checkDeleteDocument(document.id)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-layout row v-if="showCheckDeleteDocuments[document.id]">
                <v-flex pr-2>
                  <v-btn icon @click="deleteDocument(document.id)">
                    <v-icon>check</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex pl-2>
                  <v-btn icon @click="keepDocument(document.id)">
                    <v-icon>clear</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-flex>
    </v-layout>
    <v-dialog v-model="showViewPictureDialog">
      <v-img :src="pictureUrl" max-height="400" contain />
    </v-dialog>
  </v-flex>
</template>

<script>
export default {
  name: "current_files",
  props: {
    currentDocuments: { type: Array, default: () => [] },
    pictureUrl: String
  },
  data: function() {
    return {
      showCheckDeletePicture: false,
      showCheckDeleteDocuments: {},
      showViewPictureDialog: false
    };
  },
  methods: {
    checkDeletePicture: function() {
      this.showCheckDeletePicture = true;
    },
    deletePicture: function() {
      this.$emit("deletePicture");
    },
    keepPicture: function() {
      this.showCheckDeletePicture = false;
    },
    viewPicture: function() {
      this.showViewPictureDialog = true;
    },
    checkDeleteDocument: function(fileID) {
      this.showCheckDeleteDocuments[fileID] = true;
    },
    deleteDocument: function(fileID) {
      this.$emit("deleteDocument", fileID);
    },
    keepDocument: function(fileID) {
      this.showCheckDeleteDocuments[fileID] = false;
    },
    viewDocument: function(fieldID) {
      this.$emit("viewDocument", fieldID);
    }
  },
  watch: {
    currentDocuments: function() {
      let newShowCheckDeleteDocuments = {};
      this.currentDocuments.forEach(function(document) {
        newShowCheckDeleteDocuments[document.id] = false;
      });
      this.showCheckDeleteDocuments = newShowCheckDeleteDocuments;
    }
  }
};
</script>

<style>
.checkDeleteTile {
  background-color: orange;
}
</style>